import {ImagedDocument} from '../models/imaged-document.model';

export class ImagedDocumentsFactory {

  public static formatImagedDocumentsForTable(imagedDocuments: Array<ImagedDocument>) {
    const formattedImagedDocuments = [];

    imagedDocuments.forEach((document: ImagedDocument) => {
      const formattedImagedDocument = [];

      formattedImagedDocument.push(
        {
          data: document.documentType,
          class: '',
          value: document.documentID
        }
      );

      formattedImagedDocument.push(
        {
          data: document.accountType, //document.DocumentName,
          class: '',
          value: document.documentID
        }
      );

      formattedImagedDocument.push(
        {
          data: 'PDF',
          class: '',
          value: document.documentID
        }
      );

      formattedImagedDocument.push(
        {
          data: "?", //document.PageCount,
          class: '',
          value: document.documentID
        }
      );

      const formattedDate =
        document.documentDate.substr(5, 2) + '/' +
        document.documentDate.substr(8, 2) + '/' +
        document.documentDate.substr(0, 4);
      formattedImagedDocument.push(
        {
          data: formattedDate,
          class: 'amount',
          value: document.documentID
        }
      );

      formattedImagedDocuments.push(formattedImagedDocument);
    });

    return formattedImagedDocuments;
  }
}
